function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoblogofinal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.419,
    height: 36,
    viewBox: "0 0 133.419 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "mob logo final"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M420.938 163a4.937 4.937 0 0 1 4.938 4.938 4.937 4.937 0 0 1-4.938 4.938 4.937 4.937 0 0 1-4.938-4.938 4.937 4.937 0 0 1 4.938-4.938z",
    transform: "translate(-318.323 -137.111)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2507",
    d: "M420.938 108a4.937 4.937 0 0 1 4.938 4.938 4.937 4.937 0 0 1-4.938 4.938 4.937 4.937 0 0 1-4.938-4.938 4.937 4.937 0 0 1 4.938-4.938z",
    transform: "translate(-318.323 -95.043)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2508",
    d: "M420.938 53a4.937 4.937 0 0 1 4.938 4.938 4.937 4.937 0 0 1-4.938 4.938A4.937 4.937 0 0 1 416 57.938 4.937 4.937 0 0 1 420.938 53z",
    transform: "translate(-318.323 -52.976)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2509",
    d: "M475.938 163a4.937 4.937 0 0 1 4.938 4.938 4.937 4.937 0 0 1-4.938 4.938 4.937 4.937 0 0 1-4.938-4.938 4.937 4.937 0 0 1 4.938-4.938z",
    transform: "translate(-360.39 -137.111)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2510",
    d: "M475.938 108a4.937 4.937 0 0 1 4.938 4.938 4.937 4.937 0 0 1-4.938 4.938 4.937 4.937 0 0 1-4.938-4.938 4.937 4.937 0 0 1 4.938-4.938z",
    transform: "translate(-360.39 -95.043)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "M475.938 53a4.937 4.937 0 0 1 4.938 4.938 4.937 4.937 0 0 1-4.938 4.938A4.937 4.937 0 0 1 471 57.938 4.937 4.937 0 0 1 475.938 53z",
    transform: "translate(-360.39 -52.976)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M530.938 108a4.937 4.937 0 0 1 4.938 4.938 4.937 4.937 0 0 1-4.938 4.938 4.937 4.937 0 0 1-4.938-4.938 4.937 4.937 0 0 1 4.938-4.938z",
    transform: "translate(-402.458 -95.043)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.925 70.136a13.311 13.311 0 0 0-2.775-4.28 12.271 12.271 0 0 0-4.138-2.8 12.527 12.527 0 0 0-5.056-1.011 9.87 9.87 0 0 0-1.811.188 12.13 12.13 0 0 0-1.811.494 8.885 8.885 0 0 0-1.622.847 5.982 5.982 0 0 0-1.246 1.176V52.9H276v22.6a14.018 14.018 0 0 0 1.011 5.408 13.355 13.355 0 0 0 2.775 4.233 12.808 12.808 0 0 0 4.138 2.775 13.006 13.006 0 0 0 5.056.988 13.345 13.345 0 0 0 5.056-.964 12.683 12.683 0 0 0 4.138-2.728 12.954 12.954 0 0 0 2.775-4.256 14.09 14.09 0 0 0 1.011-5.456 13.706 13.706 0 0 0-1.035-5.364zm-6.02 8.089a6.554 6.554 0 0 1-1.387 2.187 6.925 6.925 0 0 1-2.069 1.481 5.918 5.918 0 0 1-2.492.517 6.1 6.1 0 0 1-2.516-.517 6.339 6.339 0 0 1-2.046-1.481 6.947 6.947 0 0 1-1.387-2.187 7.4 7.4 0 0 1-.494-2.728 6.81 6.81 0 0 1 .494-2.563 7.2 7.2 0 0 1 3.433-3.762 5.5 5.5 0 0 1 2.516-.588 5.918 5.918 0 0 1 2.492.517 6.124 6.124 0 0 1 2.069 1.458 7.06 7.06 0 0 1 1.387 2.21 7.449 7.449 0 0 1 0 5.455z",
    transform: "translate(-211.242 -52.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.674 95.492a12.091 12.091 0 0 0-4.138-2.728 12.908 12.908 0 0 0-5.056-.964 12.608 12.608 0 0 0-5.056 1.011 13.2 13.2 0 0 0-4.138 2.822 12.954 12.954 0 0 0-2.775 4.256 13.864 13.864 0 0 0-1.011 5.361 13.711 13.711 0 0 0 1.011 5.314 13.463 13.463 0 0 0 2.775 4.256 13.74 13.74 0 0 0 4.138 2.822 13.144 13.144 0 0 0 10.111 0 13.74 13.74 0 0 0 4.138-2.822 13.2 13.2 0 0 0 2.775-4.256 13.712 13.712 0 0 0 1.011-5.314 14.247 14.247 0 0 0-1.011-5.5 12.715 12.715 0 0 0-2.774-4.258zm-3.245 12.58a6.555 6.555 0 0 1-1.387 2.187 6.3 6.3 0 0 1-4.562 1.9 6.1 6.1 0 0 1-2.516-.517 6.339 6.339 0 0 1-2.046-1.481 7.108 7.108 0 0 1-1.858-4.914 7.727 7.727 0 0 1 .494-2.822 6.5 6.5 0 0 1 1.364-2.187 6.134 6.134 0 0 1 2.046-1.411 6.487 6.487 0 0 1 2.516-.494 6.288 6.288 0 0 1 2.492.494 5.418 5.418 0 0 1 2.069 1.411 6.947 6.947 0 0 1 1.387 2.187 7.954 7.954 0 0 1 0 5.643z",
    transform: "translate(-116.782 -82.653)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.043 119.865v-16.13a3.1 3.1 0 0 1 .235-1.246 3.172 3.172 0 0 1 .682-1.035 2.85 2.85 0 0 1 1.011-.682 3.285 3.285 0 0 1 1.246-.259 3.108 3.108 0 0 1 1.246.259 2.838 2.838 0 0 1 1.035.682 2.936 2.936 0 0 1 .682 1.035 3.285 3.285 0 0 1 .259 1.246v16.131h6.49v-16.131a3.1 3.1 0 0 1 .235-1.246 3.172 3.172 0 0 1 .682-1.035 2.85 2.85 0 0 1 1.011-.682 3.285 3.285 0 0 1 1.246-.259 3.108 3.108 0 0 1 1.246.259 2.838 2.838 0 0 1 1.035.682 2.936 2.936 0 0 1 .682 1.035 3.285 3.285 0 0 1 .259 1.246v16.131h6.584v-15.92a10.813 10.813 0 0 0-5.1-8.794 8.885 8.885 0 0 0-.823-.4A9.194 9.194 0 0 0 23.221 94a9.362 9.362 0 0 0-1.787.165 7.888 7.888 0 0 0-1.764.494 7.8 7.8 0 0 0-1.6.917 6.368 6.368 0 0 0-1.364 1.387 7.145 7.145 0 0 0-2.986-2.3 9.375 9.375 0 0 0-6.843-.024 10.377 10.377 0 0 0-2.492 1.387A10.856 10.856 0 0 0 .6 102.771v17.095z",
    transform: "translate(-.6 -84.336)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoblogofinal1);
export default __webpack_public_path__ + "static/media/mob logo final (1).14048704e314a402de2bb27b370557cc.svg";
export { ForwardRef as ReactComponent };